import { Box, styled } from '@creditas-ui/react'

export const CardResumeFeedStyle = styled(Box)`
  padding: 24px 32px;
`

export const FeedDescription = styled.p`
  line-height: 20px;
  overflow-y: auto;
  max-height: 225px;

  a {
    color: ${({ theme }) => theme.colors.neutral[90]};
    font-weight: bold;
  }
`
